import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const splashScreenDeleteApi = createAsyncThunk(
    'auth/splashScreens/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.splashScreenAction(`${id}`, 1))
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const splashScreenDeleteSlice = createSlice({
    name: 'splashScreen delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(splashScreenDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(splashScreenDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(splashScreenDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const splashScreenDeleteReducer = splashScreenDeleteSlice.reducer